import { UpdateContractFormModalContext } from '@/contexts'
import { useContext } from 'react'

export const useUpdateContractFormModalContext = () => {
  const context = useContext(UpdateContractFormModalContext)

  if (!context) throw new Error('useUpdateContractFromModalContext has to be wrapped by UpdateContractFromModalContextProvider')

  return context
}